import { memo } from "react";
import { Pressable } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";
import { View } from "@src/components";
import { styles } from "./CamerasTabHeader.native";
import type { FC } from "react";
import type { SharedHeaderProps } from "./CamerasTabHeader.native";

type Props = Pick<SharedHeaderProps, "onSearchPress"> & {
  variant: "legacy" | "siteWide";
  hasAlert?: boolean;
};

export const CamerasTabHeaderActions: FC<Props> = memo(({ onSearchPress, variant, hasAlert }) => {
  const { theme } = useUnistyles();
  const iconStyle = variant === "legacy" ? styles.legacyIconBtn : styles.iconBtn;
  const iconColor = theme.colors.textMuted;

  return (
    <View flexDirection="row" alignItems="center" gap="xs">
      <Pressable
        style={iconStyle}
        onPress={onSearchPress}
        accessibilityRole="button"
        accessibilityLabel="Search cameras"
      >
        <Icon name="search" size={24} color={iconColor} />
        {hasAlert && (
          <View
            style={{
              position: "absolute",
              top: 4,
              right: 4,
              width: 6,
              height: 6,
              borderRadius: 4,
              backgroundColor: theme.colors.status.error,
            }}
          />
        )}
      </Pressable>
    </View>
  );
});

CamerasTabHeaderActions.displayName = "CamerasTabHeaderActions";
